<template>
  <div>
    <script type="application/javascript" v-html="googleMapsLibraryScript"></script>
    <div id="map">
    </div>
  </div>
</template>


<script>
  import logger from '../../lib/logger';
  export default {
    data () {
      return {
        mapId: '5405b356d1bcb251',
        map_data: { lat: this.value.lat, lon: this.value.lon },
        api_key: process.env.GOOGLE_APIKEY,
      }
    },
    props: {
      zoom: {
        required: false,
        type: Number,
        default: 20
      },
      map_type: {
        required: false,
        default: 'roadmap'
      },
      draggable: {
        required: false,
        default: false
      },
      value: {
        required: false,
        default: { lat: null, lon: null }
      }
    },

    // this syntax (*async* lifecycle_hook) is usually discouraged but i find it simpler here
    async mounted () {
      // Request needed libraries.
      logger.debug('GoogleMapsDraggable mounted', this.value);

      const { Map } = await google.maps.importLibrary("maps");
      const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
      const map = new Map(document.getElementById("map"), {
        center: { lat: Number(this.value.lat), lng: Number(this.value.lon) },
        zoom: this.zoom,
        mapId: this.mapId,
        mapTypeId: this.map_type
      });
      const draggableMarker = new AdvancedMarkerElement({
        map,
        position: { lat: Number(this.value.lat), lng: Number(this.value.lon) },
        gmpDraggable: this.draggable,
        title: "This marker is draggable.",
      });
      if (this.draggable){
        let self = this;
        draggableMarker.addListener("dragend", (event) => {
          const position = draggableMarker.position;
          self.map_data.lat = String(position.lat);
          self.map_data.lon = String(position.lng);
        });
      }
    },

    computed: {
      googleMapsLibraryScript(){
        // can't template `data` into a script tag for some dumb reason. So we template the api_key here and return it.
        return `
        (g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=\`https://maps.\${c}apis.com/maps/api/js?\`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
          key: "${this.api_key}",
          v: "weekly",
          // Use the 'v' parameter to indicate the version to use (weekly, beta, alpha, etc.).
          // Add other bootstrap parameters as needed, using camel case.
        });`
      },
      mapData() {
        return this.map_data;
      }
    },

    watch: {
      mapData: {
        handler(new_val, old_val) {
          this.$emit('input', new_val);
        },
        deep: true
      }
    }
  }


</script>

<style scoped>
  #map {
    min-height: 400px;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// GoogleMapsDraggable.vue?95297a72